import { user, request, debug, track, storage } from 'lib';
import { UiModal, UiToast } from 'components';
import assign from 'lodash/assign';

// import ZegoBase from 'widgets/lib/zego'
import ZegoBase from 'widgets/lib/zego';
import { getStore } from '../store';
import performanceStore from '@/client/widgets/functions/popup-performance/store';
// import {v1 as uuidv1} from 'uuid'
// import MD5 from 'blueimp-md5'

const log = debug.create('zg');
const error = debug.create('zg:error');

const STATE_TYPE = ['start', 'error', 'retry'];

class ZegoStageRoom extends ZegoBase {
  onDisconnect() {}

  onKickOut() {}

  onStreamUpdated(type, streamList) {}

  onPlayStateUpdate(type, streamId, error) {}

  onVideoSizeChanged(streamId, videoWidth, videoHeight) {}

  onPlayQualityUpdate(streamId, streamQuality) {}

  onPublishStateUpdate(type, streamId, error) {
    if (type === 0) {
      this.updatePublishState(streamId, true);
    } else if (type === 1) {
      this.updatePublishState(streamId, false);
    }

    if (error) {
      // UiToast.fail('开播状态异常，请重试');
    }
  }

  onPublishQualityUpdate(streamId, streamQuality) {
    const { videoBitrate, audioBitrate, videoFPS, videoTransferFPS } =
      streamQuality;
    performanceStore.store.updateVideoInfo({
      fps: videoTransferFPS,
      bitrate: videoBitrate,
      lostRate: videoFPS - videoTransferFPS,
    });
  }

  onLoginZego(status) {
    if (status) {
      getStore().room.updateZegoStatus(true);
    }
  }

  onInitMusicInstance(status) {
    getStore().room.updateMusicInstance(status);
  }

  onStartPublishingStream(status) {
    // if (status) {
    //   getStore().room.updatePublishingStreamStatus(true)
    // }
  }

  onStopPublishingStream() {
    // getStore().room.updatePublishingStreamStatus(false)
  }

  stopPublishingStream(video, isStopPreview) {
    video = video || document.getElementById('currentStarVideo');
    super.stopPublishingStream(video, isStopPreview);
  }

  startPreview(opts, streamType) {
    super.startPreview(opts, streamType);
    const { room } = getStore();
    room.updateStreamType(streamType);
    room.updateComplexSourceHandle(this.complexSourceHandle || 0);
  }

  updateStream(type, isJoinLive) {
    super.updateStream(type, isJoinLive);
    const { room } = getStore();
    room.updateStreamType(type);
  }

  updatePublishState(streamId, isSuccess) {
    const { room } = getStore();

    const { updatePublishingStreamStatus } = room;

    const isPublishing = isSuccess;

    updatePublishingStreamStatus(isPublishing);

    // track.send({
    //   event: 'zg_anchorRoom',
    //   event_type: 'updatePublishState',
    //   desc: '更新推流状态',
    //   params: {
    //     streamId,
    //     isSuccess
    //   }
    // })

    // request.cryolite
    //   .post(`api/v5/stage-room/user-stream-info`, {
    //     room_id: this.roomId,
    //     stream_id,
    //     type: myMic.type,
    //     status: isSuccess ? 1 : 0,
    //     live_type: 1 // pc 开播
    //   })
    //   .then((res) => {
    //     log('updatePublishState success')
    //     if (!isSuccess) {
    //       //myMic.index
    //       let video = document.getElementById('video_micIndex' + myMic.index);
    //       this.stopPublishingStream(video)
    //     }
    //   })
    //   .catch((res) => {
    //     UiToast.fail('更新推流状态失败')
    //     let video = document.getElementById('video_micIndex' + myMic.index);
    //     this.stopPublishingStream(video)
    //     log('updatePublishState error', res)
    //   })
  }

  onSoundLevelUpdate(soundLevelList) {
    // log('soundLevelList', soundLevelList)
    // soundLevelList.forEach((item) => {
    //   getStore().room.updateSoundLevel(item.streamID.split('?')[0], item.soundLevel | 0)
    // })
  }
}

const uploader = new ZegoStageRoom();
const init = async (roomId) => {
  uploader.init(
    'pcClientRoom',
    roomId,
    user.getUserId(),
    user.getUserInfo().nick_name,
  );
};

const destroy = () => {
  getStore().room.updatePublishingStreamStatus(false);
  getStore().room.updateZegoStatus(false);
  getStore().room.updatePreviewingStatus(false);
  uploader.destroy();
};

const getDeviceList = uploader.getDeviceList.bind(uploader);
const startPreview = uploader.startPreview.bind(uploader);
const stopPreview = uploader.stopPreview.bind(uploader);
const startPublishingStream = uploader.startPublishingStream.bind(uploader);
const stopPublishingStream = uploader.stopPublishingStream.bind(uploader);
const startPlayingStream = uploader.startPlayingStream.bind(uploader);
const stopPlayingStream = uploader.stopPlayingStream.bind(uploader);
const enableCamera = uploader.enableCamera.bind(uploader);
const enableMicrophone = uploader.enableMicrophone.bind(uploader);
const updateStream = uploader.updateStream.bind(uploader);
const mutePlayStreamAudio = uploader.mutePlayStreamAudio.bind(uploader);
const getSnapshot = uploader.getSnapshot
  ? uploader.getSnapshot.bind(uploader)
  : null;

export default {
  init,
  instance: uploader,
  destroy,
  getDeviceList,
  startPreview,
  stopPreview,
  startPublishingStream,
  stopPublishingStream,
  startPlayingStream,
  mutePlayStreamAudio,
  stopPlayingStream,
  enableCamera,
  enableMicrophone,
  updateStream,
  getSnapshot,
};
